

export function validateUUID ({id, hash, cache}){
    
    if(!cache || !cache.length){
        return false;
    }

    const obj = cache.find((validation) => validation.id == id);

    if(!obj){
        return false;
    }

    return obj.uuid === hash;
}